import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';

export default function ComboOffers() {
  return (
    <div className="min-h-screen py-24 bg-cream flex items-center justify-center">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Gift size={80} className="text-turmeric mx-auto mb-8" />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold text-brown-dark mb-6">
            Combo Offers
          </h1>
          <div className="bg-turmeric/20 border-2 border-dashed border-turmeric rounded-2xl p-12">
            <p className="text-3xl font-caveat text-brown-dark mb-4">
              Exciting Combo Deals
            </p>
            <p className="text-6xl font-playfair font-bold text-spice mb-6">
              Coming Soon!
            </p>
            <p className="text-lg text-brown-medium">
              Stay tuned for delicious combo offers that will make your chaat experience even more delightful
            </p>
          </div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="mt-8"
          >
            <a
              href="/menu"
              className="inline-block bg-leaf text-white px-8 py-3 rounded-full hover:bg-leaf-hover transition-all transform hover:-translate-y-1 font-bold"
              data-testid="view-menu-btn"
            >
              Explore Menu
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}